module.exports = __webpack_public_path__ + "static/media/roundaboutCW135.6933cf28.svg";